import { ReactNode } from 'react';
import { Typography } from '@weareopenr/component-library';
import styles from './InformationField.module.scss';

interface InformationFieldProps {
  heading: string;
  information: ReactNode;
}

export const InformationField = ({ heading, information }: InformationFieldProps) => {
  return (
    <div className={styles.container}>
      <Typography size="medium" weight="semi-bold">
        {heading}
      </Typography>
      <div className={styles.information}>
        {typeof information === 'string' ? (
          <Typography size="medium">{information}</Typography>
        ) : (
          information
        )}
      </div>
    </div>
  );
};
